import { useCallback, useMemo } from "react";
import { toast } from "sonner";
import Swal from 'sweetalert2';

export default function useHandleErrors() {

    const handleErrors = useCallback((response: any, refetch?: () => void) => {
        const payload = response?.response?.data ?? response;

        if (!payload || typeof payload !== 'object') {
            toast.error('Se ha producido un error inesperado');
            return;
        }

        if (!payload.success) {
            if (payload.data?.errors) {
                payload.data.errors?.forEach((error: any) => {
                    if (error.warning) toast.warning(error.message)
                    else toast.error(error.message);
                });
            } else {
                if (payload.warning) {
                    let warningMessage: string[] = [];
                    try {
                        warningMessage = JSON.parse(payload.message);
                    } catch {
                        warningMessage = [String(payload.message || 'Acción finalizada con avisos')];
                    }

                    const warningList = warningMessage?.map((warning: string) => `<li>${warning}</li>`).join("");
                    Swal.fire({
                        title: 'Acción finalizada',
                        html: `<ul style="text-align: left; padding-left: 20px;">${warningList}</ul>`,
                        icon: 'info',
                        confirmButtonColor: '#009737',
                        confirmButtonText: 'Cerrar',
                    }).then(() => {
                        if (refetch) refetch();
                    });
                } else {
                    if (Array.isArray(payload.message)) {
                        const messageList = payload.message?.map((message: string) => `<li>${message}</li>`).join("");
                        Swal.fire({
                            title: 'Error',
                            html: `<ul style="text-align: left; padding-left: 20px;">${messageList}</ul>`,
                            icon: 'info',
                            confirmButtonColor: '#009737',
                            confirmButtonText: 'Cerrar'
                        });
                    } else {
                        toast.error(payload.message || 'Se ha producido un error inesperado');
                    }
                }
            }
        }
    }, []);

    return useMemo(() => ({ handleErrors }), [handleErrors]);
}
